<div class="raptor-call-to-action-container">  
  <button mat-stroked-button color="secondary" type="button" (click)="openMedical()">{{ buttonLabel }}</button>
</div>
